"use strict";

require("core-js/modules/es.array.reduce.js");

function _typeof(t) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
    return typeof t;
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  })(t);
}

var __createBinding = Object.create ? function (t, e, i, n) {
  void 0 === n && (n = i), Object.defineProperty(t, n, {
    enumerable: !0,
    get: function get() {
      return e[i];
    }
  });
} : function (t, e, i, n) {
  void 0 === n && (n = i), t[n] = e[i];
},
    __setModuleDefault = Object.create ? function (t, e) {
  Object.defineProperty(t, "default", {
    enumerable: !0,
    value: e
  });
} : function (t, e) {
  t.default = e;
},
    __importStar = function __importStar(t) {
  if (t && t.__esModule) return t;
  var e = {};
  if (null != t) for (var i in t) {
    "default" !== i && Object.hasOwnProperty.call(t, i) && __createBinding(e, t, i);
  }
  return __setModuleDefault(e, t), e;
};

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.calculateInitialState = exports.getItemsInSlide = exports.getStageContentWidth = exports.getIsStageContentPartial = void 0;

var Utils = __importStar(require("."));

exports.getIsStageContentPartial = function (t, e) {
  return void 0 === t && (t = 0), void 0 === e && (e = 0), e <= t;
}, exports.getStageContentWidth = function (t) {
  var e = t.infinite,
      i = t.itemsCount,
      n = void 0 === i ? 0 : i,
      o = t.itemsInSlide,
      i = void 0 === o ? 1 : o,
      o = t.itemsOffset,
      o = void 0 === o ? 0 : o,
      t = t.transformationSet,
      t = void 0 === t ? [] : t;

  if (e) {
    o = Utils.getShiftIndex(i, o);
    return t.slice(o, o + n).reduce(function (t, e) {
      return t + e.width;
    }, 0);
  }

  t = t[n - 1] || {}, n = t.position, t = t.width;
  return (void 0 === n ? 0 : n) + (void 0 === t ? 0 : t);
}, exports.getItemsInSlide = function (e, t) {
  var i = 1,
      n = t.responsive,
      o = t.autoWidth,
      o = void 0 !== o && o,
      t = t.infinite;
  return o && void 0 !== t && t ? i = e : !n || (t = Object.keys(n)).length && "object" === ("undefined" == typeof window ? "undefined" : _typeof(window)) && t.forEach(function (t) {
    Number(t) < window.innerWidth && (i = Math.min(n[t].items, e) || i);
  }), i;
}, exports.calculateInitialState = function (t, e) {
  var i = t.animationDuration,
      n = void 0 === i ? 0 : i,
      o = t.infinite,
      a = void 0 !== o && o,
      r = t.autoPlay,
      s = void 0 !== r && r,
      l = t.autoWidth,
      f = void 0 !== l && l,
      u = Utils.createClones(t),
      d = Utils.getTransitionProperty(),
      m = Utils.getItemsCount(t),
      c = Utils.getItemsOffset(t),
      g = exports.getItemsInSlide(m, t),
      p = Utils.getStartIndex(t.activeIndex, m),
      S = Utils.getDotsNavigationLength(m, g, f),
      v = Utils.getActiveIndex(p, S, a),
      i = Utils.getElementDimensions(e).width,
      o = f ? Utils.createAutowidthTransformationSet(e) : Utils.createDefaultTransformationSet(u, i, g),
      r = Utils.getTransformationSetItem(-g, o).position,
      l = exports.getStageContentWidth({
    itemsCount: m,
    itemsInSlide: g,
    itemsOffset: c,
    transformationSet: o,
    infinite: a
  }),
      p = exports.getIsStageContentPartial(i, l),
      S = Utils.getSwipeLimitMin({
    itemsOffset: c,
    transformationSet: o
  }, t),
      e = Utils.getSwipeLimitMax({
    itemsCount: m,
    itemsOffset: c,
    itemsInSlide: g,
    transformationSet: o
  }, t),
      t = Utils.getSwipeShiftValue(m, o);
  return {
    activeIndex: v,
    autoWidth: f,
    animationDuration: n,
    clones: u,
    infinite: a,
    itemsCount: m,
    itemsInSlide: g,
    itemsOffset: c,
    translate3d: Utils.getTranslate3dProperty(v, {
      itemsInSlide: g,
      itemsOffset: c,
      transformationSet: o,
      autoWidth: f,
      infinite: a
    }),
    stageWidth: i,
    stageContentWidth: l,
    initialStageHeight: 0,
    isStageContentPartial: p,
    isAutoPlaying: Boolean(s),
    isAutoPlayCanceledOnAction: !1,
    transformationSet: o,
    transition: d,
    fadeoutAnimationIndex: null,
    fadeoutAnimationPosition: null,
    fadeoutAnimationProcessing: !1,
    swipeLimitMin: S,
    swipeLimitMax: e,
    swipeAllowedPositionMax: r,
    swipeShiftValue: t
  };
};